import { AuthLayout } from "auth";
import flows from "config/flow-specs";

import { useGetUserDetails } from "auth/auth-state";

interface Props {
  flowName: string;
  children: React.ReactNode;
}

const Layout = ({ flowName, children }: Props) => {
  const userDetails = useGetUserDetails();

  const flow = flows.find((f) => f.link === flowName);

  if (!flow) {
    return null;
  }

  if (userDetails.is_admin || flow.public) {
    return <>{children}</>;
  }

  if (!userDetails.private_flows?.includes(flowName)) {
    return null;
  }

  return <>{children}</>;
};

const Wrapper = (props: Props) => (
  <AuthLayout>
    <Layout {...props} />
  </AuthLayout>
);

export default Wrapper;
